import RowNode from './RowNode.vue';
import ColNode from './ColNode.vue';
import ListNode from './ListNode.vue';
import MarkdownStreamNode from './MarkdownStreamNode.vue';
import ProgressBarNode from './ProgressBarNode.vue';
import GroupLinkNode from './GroupLinkNode.vue';
import CampaignLinkNode from './CampaignLinkNode.vue';
import TodoNode from './TodoNode.vue';

// Default component registry
// Maps nodeType strings to Vue components
export default {
  row: RowNode,
  col: ColNode,
  list: ListNode,
  markdownStream: MarkdownStreamNode,
  progressBar: ProgressBarNode,
  groupLink: GroupLinkNode,
  campaignLink: CampaignLinkNode,
  todo: TodoNode,
};
